import PaginaFaq from "./PaginaFaq";
export default PaginaFaq;